import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginCredentials } from '../model/login-credentials.model';
import { MessageToastService } from '@services/message-toast.service';

export class LoginFormModel {
  public readonly form: FormGroup;

  constructor(
    private fb: FormBuilder, 
    private messageToastService: MessageToastService
  ) {
    this.form = this.initLoginForm();
  }

  private initLoginForm(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  public validate(
    errorMessage: string = 'Completa los campos requeridos.'
  ): boolean {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.messageToastService.error([errorMessage]);
      return false;
    }
    return true;
  }

  public getCredentials(): LoginCredentials {
    return this.form.value as LoginCredentials;
  }
}
